module.exports = __webpack_public_path__ + "media/images/carbon_hospitals/common/surgicals/img_q-f225b98c0b0fb2dab32cad397f8abf54.png";